import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { accountsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Projects($search: String, $page: Int, $fromTemplates: Boolean) {
    projects(search: $search, page: $page, fromTemplates: $fromTemplates, sort: { field: NAME, type: ASC }) {
      id
      name
    }
  }
`

export const useProjectLoader = ({ fromTemplates }) => {
  const query = usePromiseQuery(QUERY, { fetchPolicy: 'no-cache', client: accountsClient })
  return (search, page = 1) => {
    return query({ search, page, fromTemplates })?.then(pathOr([], ['data', 'projects']))
  }
}

const ProjectSelect = ({ onChange, value, fromTemplates, ...props }) => {
  const getOptions = useProjectLoader({ fromTemplates })

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      {...props}
    />
  )
}

export default ProjectSelect
